export const FETCH_APPLICATION = 'FETCH_APPLICATION';
export const FETCH_APPLICATION_SUCCESS = 'FETCH_APPLICATION_SUCCESS';
export const FETCH_APPLICATION_ERROR = 'FETCH_APPLICATION_ERROR';

export const DISCARD_APPLICATION_LOADING = 'DISCARD_APPLICATION_LOADING';
export const DISCARD_APPLICATION_ERROR = 'DISCARD_APPLICATION_ERROR';
export const DISCARD_APPLICATION_SUCCESS = 'DISCARD_APPLICATION_ERROR';
